import React from 'react';
import { Segmented } from 'antd';
import './DashboardSwitch.css';

export type DashSection = 'income' | 'expense' | 'orders' | 'inbound' | 'inventory';

type Props = {
  value: DashSection;
  onChange: (v: DashSection) => void;
  /** размер визуальный: sm | md | lg */
  uiSize?: 'sm' | 'md' | 'lg';
};

const DashboardSwitch: React.FC<Props> = ({ value, onChange, uiSize = 'md' }) => {
  return (
    <Segmented
      className={`dash-tabs dash-tabs--${uiSize}`}
      value={value}
      onChange={(v) => onChange(v as DashSection)}
      options={[
        { label: 'Доход', value: 'income' },
        { label: 'Расход', value: 'expense' },
        { label: 'Заказы', value: 'orders' },
        { label: 'Поступления', value: 'inbound' },
        { label: 'Склад', value: 'inventory' },
      ]}
    />
  );
};

export default DashboardSwitch;
